import { Component } from "@angular/core";

@Component({
  selector: "app-comite-home",
  templateUrl: "./comite-home.component.html",
  styleUrls: ["./comite-home.component.css"],
})
export class ComiteHomeComponent {}
